export default [
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/menu/user/user.vue'),
    meta: {
      pageTitle: 'کاربران',
      action: 'show',
      resource: 'UserManager',
    },
  },
  {
    path: '/userrole',
    name: 'userrole',
    component: () => import('@/views/menu/user/userrole.vue'),
    meta: {
      pageTitle: 'نقش ها',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details',
    name: 'adduserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ایجاد نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details/:id',
    name: 'updateuserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ویرایش نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
]
